export function setCookie(name: string, value: string, daysToLive = 30) {
  let cookieString = encodeURIComponent(name) + '=' + encodeURIComponent(value);

  if (daysToLive) {
    const date = new Date();
    date.setTime(date.getTime() + daysToLive * 24 * 60 * 60 * 1000);
    cookieString += '; expires=' + date.toUTCString();
  }

  cookieString += '; path=/; SameSite=Lax; Secure';
  document.cookie = cookieString;
}

export function clearCookie(name: string) {
  document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax; Secure`;
}

export function getCookie(name: string) {
  const nameEQ = encodeURIComponent(name) + '=';
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
}
